export default function (id, username) {
  let window = id ? `usuario.${id}` : 'usuario.new'
  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: 'Usuário' + (username ? ` #${username}` : ''),
    width: '800',
    height: '700',
    minHeight: '500px',
    backdrop: false,
    clickOutside: false,
    windowClass: 'erp-window',
    contentClass: 'overflow-hidden',
    props: {
      id: id
    }
  }, () => import('../components/window/Usuario.vue'))
    .then((wid) => {
      console.log(wid)
      this.$uloc.window.listen(wid, {
        updated: (wid, user) => {
          this.load()
        }
      })
    }) // return wid
}
